import React from "react";
import { View, Text, StyleSheet } from "@react-pdf/renderer";
import generalStyle from "../GeneralStyles";

export const TextArea = ({ text }) => {
  const textAreaBlock = StyleSheet.create({
    textArea: {
      marginTop: 3,
      height: 100,
      backgroundColor: "white",
      border: "1 solid black",
    },
    container: {
      marginTop: 7,
    },
    text: {
      ...generalStyle.semiBold,
      fontSize: 10,
    },
  });

  return (
    <View data-testid="report-textarea" style={textAreaBlock.container}>
      <Text style={textAreaBlock.text}>{text}</Text>
      <View style={textAreaBlock.textArea}></View>
    </View>
  );
};
